/** @jsxImportSource theme-ui @jsxRuntime classic */
import React, { ComponentPropsWithRef, forwardRef, createElement } from 'react';
import { Text } from '@tishman/components';

import { SectionLevel, useSectionLevel } from './sectionLevel';

import type { ThemeUIStyleObject } from 'theme-ui';

export interface HProps extends Omit<ComponentPropsWithRef<'h1'>, 'ref'> {
  /**
   * One of the six possible HTML5 Sectioning levels to use: 1—6.
   * If this is defined, it will be used instead
   * of the nearest sectioning context.
   */
  level?: SectionLevel;
  sx?: ThemeUIStyleObject;
  ref?: React.Ref<HTMLHeadingElement | HTMLDivElement>;
}

export const H = forwardRef<HTMLHeadingElement | HTMLDivElement, HProps>(
  ({ level, sx, ...props }, ref): React.JSX.Element => {
    const sectionLevel = useSectionLevel();

    return (
      <Text as={`h${level || sectionLevel}`} ref={ref} sx={sx} {...props} />
    );
  },
);
H.displayName = 'H';
